export default __webpack_public_path__ + "static/media/051-equation.f74b8e53.svg";